module.exports = __webpack_public_path__ + "static/img/close-video-icon.873bbe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close-video-icon.png
// module id = 720L
// module chunks = 208